import {
   MultiSelect as MantineMultiSelect,
   MultiSelectProps as MantineMultiSelectProps,
} from '@mantine/core'
import styles from './MultiSelect.module.scss'
import cn from 'classnames'

export const MultiSelect = ({
   checkIconPosition = 'right',
   ...props
}: MantineMultiSelectProps) => {
   return (
      <MantineMultiSelect
         checkIconPosition={checkIconPosition}
         classNames={{
            input: cn(styles['text-input']),
            label: 'text-white/90 font-medium mb-1.5',
            dropdown: 'bg-black rounded-lg p-2',
            description: 'pt-0.5',
            pill: 'rounded-md border border-[#9F7BFF]/40 text-xs bg-[rgba(159,123,255,0.20)]',
         }}
         inputWrapperOrder={['label', 'input', 'description', 'error']}
         {...props}
      />
   )
}
